import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Loadable.css';

class Loadable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { loadingClasses, loading, className, count, ...rest } = this.props;

    if (loading) {
      let skeletonClasses = loadingClasses.map(c => styles[`skeleton-${c}`]);
      let loadingItem = <div className={classNames("hx-skeleton", styles.skeleton, skeletonClasses, className)} {...rest}>&nbsp;</div>;

      if (count > 1) {
        let results = [];
        for(let i = 0; i < count; i++) {
          results.push(React.cloneElement(loadingItem, { key: `item-${i}`}));

          if (i < (count - 1)) {
            results.push(<div className={styles.divider} key={`divider-${i}`} />);
          }
        }

        return (
          <div>
            {results}
          </div>
        );
      }

      return loadingItem;
    }
    else {
      return <div style={{display: 'inline'}}>{this.props.children}</div>;
    }
  }
}

Loadable.propTypes = {
  count: PropTypes.number,
  loading: PropTypes.bool,
  loadingClasses: PropTypes.array
};

Loadable.defaultProps = {
  count: 1,
  loading: false,
  loadingClasses: []
};

export default Loadable;
